'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactIs = {exports: {}};

exports.reactIs = reactIs;
